import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { pick, asList, fmtDateTime } from "@/lib/admin-utils";
import { Skeleton } from "@/components/ui/skeleton";
import { Flag } from "lucide-react";

export function AdminReports() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["admin-reports"],
    queryFn: async () => (await api.get("/admin/reports")).data,
    retry: false,
  });

  const reports = asList(data);

  return (
    <div className="px-4 sm:px-6 pt-5 space-y-4" data-testid="admin-reports-page">
      <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Segnalazioni</h1>

      {isLoading ? (
        <div className="space-y-3">{[1, 2].map((i) => <Skeleton key={i} className="h-20 rounded-3xl" />)}</div>
      ) : reports.length ? (
        <div className="space-y-3" data-testid="reports-list">
          {reports.map((r, i) => (
            <div key={r.id || i} data-testid={`report-${r.id || i}`} className="bg-white rounded-3xl border border-slate-100 shadow-sm p-4 space-y-1">
              <p className="font-semibold text-slate-900 text-sm">{pick(r, ["reason", "title", "type"], "Segnalazione")}</p>
              <p className="text-xs text-slate-500">{pick(r, ["description", "text", "details"], "")}</p>
              <p className="text-xs text-slate-400">Da: {pick(r, ["reporter", "user_id", "reporter_id"], "—")} · {fmtDateTime(pick(r, ["created_at"]))}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-3xl border border-dashed border-slate-200 p-8 text-center space-y-2" data-testid="reports-empty">
          <Flag className="w-8 h-8 text-slate-300 mx-auto" />
          <p className="text-sm font-semibold text-slate-700">Sezione segnalazioni pronta</p>
          <p className="text-xs text-slate-500 leading-relaxed">
            Qui appariranno le segnalazioni di utenti, professionisti e contenuti non appena il flusso di segnalazione sarà attivo lato app e web.
          </p>
        </div>
      )}
    </div>
  );
}
